import { sectionRenderer } from '@theme/section-renderer';

/**
 * <pdp-size-picker> — size tiles are <a> links to colour-preserving variant URLs.
 * Sizes are variants of the SAME product, so instead of a full page navigation we
 * soft-render only the pdp-information section (like the colour picker) and
 * update the URL. The whole section is morphed, so price / add-to-cart / colour
 * picker all stay in sync with the new variant. Without JS the links still work.
 */
class PdpSizePicker extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
  }

  /** @param {MouseEvent} event */
  #onClick = (event) => {
    if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;

    const link = /** @type {HTMLElement} */ (event.target)?.closest?.('a.pdp-variant-card');
    if (!(link instanceof HTMLAnchorElement)) return;
    if (link.getAttribute('aria-disabled') === 'true' || link.classList.contains('is-selected')) {
      event.preventDefault();
      return;
    }

    const section = this.closest('.shopify-section');
    const sectionId = section?.id?.replace(/^shopify-section-/, '');
    if (!sectionId) return; // no section context → let the browser navigate normally

    event.preventDefault();
    const url = new URL(link.href, window.location.origin);
    history.replaceState({}, '', url.toString());
    sectionRenderer.renderSection(sectionId, { url });
  };
}

if (!customElements.get('pdp-size-picker')) {
  customElements.define('pdp-size-picker', PdpSizePicker);
}
